import React, { useEffect, useState } from "react";
import { useEtatGlobal } from "../EtatGlobal.js";
import { authFetch } from '../../HttpClient';
// import MissionPopup from "../Portefeuille/Mission.js";
import EditTodoForm from "./EditTodoForm"; // adapte le chemin si nécessair
import PreparationPopup from "./Preparation.js";
import DiligencePopup from "./Diligences.js";
import EvenementPopup from "./Evenement.js";
import VerificationPopup from "./Verification.js";
import AutresPopup from "./AutresTodo.js";
import DextPopup from "./Dext.js";
import ModifSct from "./Mission/modificationSociete.js";
import CessionDroit from "./Mission/cessionDroitSoc.js";
import CreationSct from "./Mission/creationSoc.js";
import Radiation from "./Mission/radiation.js";

import { AiOutlineDelete } from "react-icons/ai";
import { HiMiniArchiveBox } from "react-icons/hi2";

import { useMemo, useRef } from "react";
import { CiFilter } from "react-icons/ci";

import "./ToDo.css";
import CreateTodo from "./CreateTodo.js";
import Archives from "./Archive.js";

import { IoIosSearch } from "react-icons/io";

import {
  Archive,
  Plus,
  ChevronDown,
  AlertCircle,
  CheckCircle2,
  MoreHorizontal,
  Pencil,
  Trash2,
} from "lucide-react";

import { isPast, parseISO, startOfDay } from "date-fns";

import { dialog } from "../../components/ui/Dialog";
function ToDo() {
  const {
    utilisateur,
    todos,
    setTodos,
    fetchTodos,
    patchTodoLocal,
    removeTodoLocal,
  } = useEtatGlobal();
  const [selectedClient, setSelectedClient] = useState(null);

  const [showEditForm, setShowEditForm] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editTodo, setEditTodo] = useState(null);

  const [showArchives, setShowArchives] = useState(false);

  const [showAddDiv, setShowAddDiv] = useState(false);
  // const [archivingTodoId, setArchivingTodoId] = useState(null);

  const [collapsedUsers, setCollapsedUsers] = useState({});

  const [searchClient, setSearchClient] = useState("");

  const [selectedTodos, setSelectedTodos] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isArchiving, setIsArchiving] = useState(false);
  const [selectedUserKey, setSelectedUserKey] = useState(null);

  const [openMenuId, setOpenMenuId] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
  const [selectedMenuTodo, setSelectedMenuTodo] = useState(null);
  const [animatingId, setAnimatingId] = useState(null);

  const toggleSelection = (id) => {
    setSelectedTodos((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
    );
  };

  // Ajoute les champs manquants dans formData
  const [formData, setFormData] = useState({
    title: "",
    status: "",
    nomClient: "",
    clientId: "",
    nature: "",
    dueDate: "",
    priority: "",
    commentaire: "",
    userIds: [],
  });

  // Filtrer les todos à afficher selon le user sélectionné

  // Ouverture instantanée : les données du todo sont déjà dans la ligne
  // cliquée, inutile de les re-télécharger depuis l'API
  const handleEditClick = (todo) => {
    setEditTodo(todo);
    setFormData({
      title: todo.title,
      status: todo.status,
      nomClient: todo.nomClient,
      clientId: todo.clientId,
      nature: todo.nature || "",
      dueDate: todo.dueDate
        ? new Date(todo.dueDate).toISOString().slice(0, 16)
        : "",
      priority: todo.priority || "",
      commentaire: todo.commentaire || "",
      userIds: (todo.users || []).map((user) => user.id),
    });
    setEditLoading(false);
    setShowEditForm(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUserIdsChange = (e) => {
    const ids = e.target.value.split(",").map((id) => parseInt(id.trim()));
    setFormData((prev) => ({
      ...prev,
      userIds: ids,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const todoId = editTodo.id;
    const payload = {
      ...formData,
      dueDate: formData.dueDate
        ? new Date(formData.dueDate).toISOString()
        : null,
    };

    // UI instantanée : la ligne reflète la modification et le formulaire se
    // ferme tout de suite, la sauvegarde se fait en arrière-plan
    patchTodoLocal(todoId, payload);
    setShowEditForm(false);
    setEditTodo(null);
    setFormData({
      title: "",
      status: "",
      nomClient: "",
      clientId: "",
      nature: "",
      dueDate: "",
      priority: "",
      commentaire: "",
      userIds: [],
    });

    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todoId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) throw new Error("Erreur lors de la mise à jour");

      // resynchronise (notamment la liste des collaborateurs affichés)
      fetchTodos();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du todo :", error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("❌ La mise à jour de la tâche a échoué.");
    }
  };

  // const isDueDatePastOrToday = (dueDate) => {
  //   if (!dueDate) return false;

  //   const today = new Date();
  //   const dateToday = new Date(
  //     today.getFullYear(),
  //     today.getMonth(),
  //     today.getDate()
  //   );

  //   const due = new Date(dueDate);
  //   const dueDateOnly = new Date(
  //     due.getFullYear(),
  //     due.getMonth(),
  //     due.getDate()
  //   );

  //   return dueDateOnly <= dateToday;
  // };

  // const isDueDateSoon = (dueDate) => {
  //   if (!dueDate) return false;

  //   const today = new Date();
  //   const dateToday = new Date(
  //     today.getFullYear(),
  //     today.getMonth(),
  //     today.getDate()
  //   );

  //   const due = new Date(dueDate);
  //   const dueDateOnly = new Date(
  //     due.getFullYear(),
  //     due.getMonth(),
  //     due.getDate()
  //   );

  //   const diffTime = dueDateOnly - dateToday;
  //   const diffDays = diffTime / (1000 * 60 * 60 * 24);

  //   return diffDays > 0 && diffDays <= 2;
  // };

  // filtre
  const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  const [filterRows, setFilterRows] = useState([
    { column: "status", selectedValues: [] },
  ]);
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (overlayRef.current && !overlayRef.current.contains(e.target)) {
        setShowFilterOverlay(false);
      }
    };

    if (showFilterOverlay)
      document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showFilterOverlay]);

  const uniqueValues = useMemo(() => {
    const dict = {
      status: [],
      priority: [],
      nomClient: [],
      title: [],
      users: [],
      dueDate: [],
    };

    // Parcourir chaque bloc de user
    todos.forEach((userBlock) => {
      userBlock.todos.forEach((todo) => {
        if (todo.status) dict.status.push(todo.status);
        if (todo.priority) dict.priority.push(todo.priority);
        if (todo.nomClient) dict.nomClient.push(todo.nomClient);
        if (todo.title) dict.title.push(todo.title);
        if (todo.dueDate) {
          const formattedDate = new Date(todo.dueDate).toLocaleDateString();
          dict.dueDate.push(formattedDate);
        }
        if (Array.isArray(todo.users)) {
          todo.users.forEach((user) => {
            if (user.name || user.lastName) {
              dict.users.push(
                `${user.name || ""} ${user.lastName || ""}`.trim()
              );
            }
          });
        }
        // Ajouter le parent du bloc pour être sûr qu'il apparaisse dans le filtre users
        dict.users.push(
          `${userBlock.name || ""} ${userBlock.lastName || ""}`.trim()
        );
      });
    });

    // Supprimer les doublons
    Object.keys(dict).forEach((key) => {
      dict[key] = Array.from(new Set(dict[key]));
    });

    return dict;
  }, [todos]);

  const handleAddFilter = () => {
    setFilterRows((prev) => [
      ...prev,
      { column: "status", selectedValues: [] },
    ]);
  };

  const handleRemoveFilter = (idx) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleFilterChange = (idx, field, value) => {
    setFilterRows((prev) =>
      prev.map((f, i) =>
        i === idx ? { ...f, [field]: value, selectedValues: [] } : f
      )
    );
  };

  const handleCheckboxValueChange = (idx, val) => {
    setFilterRows((prev) =>
      prev.map((f, i) => {
        if (i !== idx) return f;
        const sel = Array.isArray(f.selectedValues) ? f.selectedValues : [];
        const updated = sel.includes(val)
          ? sel.filter((v) => v !== val)
          : [...sel, val];
        return { ...f, selectedValues: updated };
      })
    );
  };

  // 1️⃣ filteredTodos reste le même
  const filteredTodosByUserBlock = useMemo(() => {
    return todos.map((userBlock) => {
      const filtered = userBlock.todos
        .filter((todo) => {
          return filterRows.every((filter) => {
            if (!filter.selectedValues || filter.selectedValues.length === 0)
              return true;

            if (filter.column === "users") {
              // On ajoute le userBlock du parent pour matcher correctement
              const allUsers = [
                ...(todo.users || []),
                { name: userBlock.name, lastName: userBlock.lastName },
              ];
              return allUsers.some((user) =>
                filter.selectedValues.includes(
                  `${user.name || ""} ${user.lastName || ""}`.trim()
                )
              );
            }

            if (filter.column === "dueDate") {
              const formattedDueDate = todo.dueDate
                ? new Date(todo.dueDate).toLocaleDateString()
                : "";
              return filter.selectedValues.includes(formattedDueDate);
            }

            return filter.selectedValues.includes(todo[filter.column]);
          });
        })
        .filter((todo) =>
          searchClient.trim() === ""
            ? true
            : todo.nomClient?.toLowerCase().includes(searchClient.toLowerCase())
        );

      return {
        ...userBlock,
        todos: filtered,
      };
    });
  }, [todos, filterRows, searchClient]);

  // 2️⃣ Regrouper filteredTodos par user
  // const filteredTodosByUser = useMemo(() => {
  //   const map = {};

  //   filteredTodos.forEach((todo) => {
  //     // Chaque todo peut avoir plusieurs users
  //     (todo.users || []).forEach((user) => {
  //       const userKey = `${user.name} ${user.lastName}`.trim();
  //       if (!map[userKey]) {
  //         map[userKey] = {
  //           name: user.name,
  //           lastName: user.lastName,
  //           todos: [],
  //         };
  //       }
  //       map[userKey].todos.push(todo);
  //     });
  //   });

  //   // Si un todo n’a pas de user, le mettre sous "Inconnu"
  //   filteredTodos.forEach((todo) => {
  //     if (!todo.users || todo.users.length === 0) {
  //       if (!map["Inconnu"]) {
  //         map["Inconnu"] = { name: "Inconnu", lastName: "", todos: [] };
  //       }
  //       map["Inconnu"].todos.push(todo);
  //     }
  //   });

  //   return Object.entries(map).map(([key, value]) => ({
  //     userKey: key,
  //     ...value,
  //   }));
  // }, [filteredTodos]);

  const handleMultiArchive = async () => {
    // Confirmation AVANT de passer en état "Archivage..." — sinon un refus
    // laissait le bouton bloqué sur "Archivage..." pour toujours
    const confirmArchive = await dialog.confirm(
      `Voulez-vous archiver ${selectedTodos.length} tâche(s) ?`
    );
    if (!confirmArchive) return;

    setIsArchiving(true);
    const ids = [...selectedTodos];
    // `todos` est une structure imbriquée : on cherche chaque tâche dans les
    // blocs utilisateur pour conserver son statut d'origine (lastStatus)
    const lastStatusById = Object.fromEntries(
      ids.map((id) => [id, findTodoById(id)?.status])
    );

    // UI instantanée : les lignes partent aux archives tout de suite
    ids.forEach((id) =>
      patchTodoLocal(id, { status: "Archiver", lastStatus: lastStatusById[id] })
    );
    setSelectedTodos([]);

    try {
      await Promise.all(
        ids.map((id) =>
          authFetch(`https://backend-myalfa.vercel.app/api/todos/${id}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              status: "Archiver",
              lastStatus: lastStatusById[id],
            }),
          })
        )
      );

      fetchTodos(); // resynchronise
    } catch (error) {
      console.error("Erreur lors de l'archivage multiple :", error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("Une erreur est survenue lors de l'archivage.");
    } finally {
      setIsArchiving(false);
    }
  };

  const handleMultiDelete = async () => {
    const confirmDelete = await dialog.confirm(
      `Voulez-vous vraiment supprimer ${selectedTodos.length} tâche(s) ?`
    );
    if (!confirmDelete) return;

    setIsDeleting(true);
    const ids = [...selectedTodos];

    // UI instantanée : les lignes disparaissent tout de suite
    ids.forEach((id) => removeTodoLocal(id));
    setSelectedTodos([]);

    try {
      await Promise.all(
        ids.map((id) =>
          authFetch(`https://backend-myalfa.vercel.app/api/todos/${id}`, {
            method: "DELETE",
          })
        )
      );

      fetchTodos(); // resynchronise
    } catch (error) {
      console.error("Erreur lors de la suppression multiple :", error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("Une erreur est survenue lors de la suppression multiple.");
    } finally {
      setIsDeleting(false);
    }
  };

  // const groupTodosByUser = (todos, utilisateur) => {
  //   const userMap = {};

  //   todos.forEach((todo) => {
  //     if (Array.isArray(todo.users)) {
  //       todo.users.forEach((user) => {
  //         const role = (user.role || "").trim().toUpperCase(); // ✅ normalisation du rôle
  //         const fullName = `${user.name || ""} ${user.lastName || ""}`.trim();

  //         if (utilisateur.role === "SECRETARIAT") {
  //           // 🔹 On ne prend que les ASSISTANT
  //           if (role === "ASSISTANT" || role === "SECRETARIAT") {
  //             if (!userMap[fullName]) {
  //               userMap[fullName] = [];
  //             }
  //             userMap[fullName].push(todo);
  //           }
  //         } else {
  //           // 🔹 Cas normal → tous les utilisateurs regroupés par nom
  //           if (!userMap[fullName]) {
  //             userMap[fullName] = [];
  //           }
  //           userMap[fullName].push(todo);
  //         }
  //       });
  //     }
  //   });

  //   return userMap;
  // };

  const toggleUserCollapse = (userName) => {
    setCollapsedUsers((prev) => ({
      ...prev,
      [userName]: !prev[userName],
    }));
  };

  const isOverdue = (todo) => {
    if (!todo?.dueDate) return false;
    return (
      isPast(startOfDay(parseISO(todo.dueDate))) &&
      todo.status !== "Terminer" &&
      todo.status !== "Archiver"
    );
  };

  const isTerminer = (todo) => {
    return todo?.status === "Terminer";
  };

  const userStats = useMemo(() => {
    return filteredTodosByUserBlock.map((userBlock) => {
      const finalise = userBlock.todos.filter(
        (todo) => todo.status === "Terminer"
      ).length;

      const total = userBlock.todos.filter(
        (todo) => todo.status !== "Archiver"
      ).length;

      const enCours = total - finalise;

      // Calcul automatique des todos en retard
      const enRetard = userBlock.todos.filter((todo) => isOverdue(todo)).length;

      return {
        userKey: userBlock.userKey,
        name: `${userBlock.name} ${userBlock.lastName}`,
        total,
        finalise,
        enCours,
        enRetard,
      };
    });
  }, [filteredTodosByUserBlock]);

  const displayedTodos = useMemo(() => {
    if (!selectedUserKey) return filteredTodosByUserBlock;
    return filteredTodosByUserBlock.filter(
      (userBlock) => userBlock.userKey === selectedUserKey
    );
  }, [selectedUserKey, filteredTodosByUserBlock]);

  const handleMenuToggle = (e, todo) => {
    e.stopPropagation();
    if (openMenuId === todo.id) {
      setOpenMenuId(null);
      setSelectedMenuTodo(null);
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuHeight = 170;
    const top =
      rect.bottom + menuHeight > window.innerHeight
        ? rect.top - menuHeight
        : rect.bottom;
    setMenuPosition({ top, right: window.innerWidth - rect.right });
    setOpenMenuId(todo.id);
    setSelectedMenuTodo(todo);
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenMenuId(null);
      setSelectedMenuTodo(null);
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Retrouve un todo dans la structure imbriquée (blocs par utilisateur)
  const findTodoById = (todoId) =>
    todos.flatMap((block) => block.todos || []).find((t) => t.id === todoId);

  const handleValidate = async (todoId) => {
    // UI instantanée : la ligne passe en "Terminer" tout de suite,
    // l'appel API se fait en arrière-plan
    patchTodoLocal(todoId, { status: "Terminer" });
    setOpenMenuId(null);
    setSelectedMenuTodo(null);
    setAnimatingId(todoId);
    setTimeout(() => setAnimatingId(null), 1300);

    try {
      const response = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todoId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: "Terminer",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la mise à jour");
      }

      fetchTodos();
    } catch (error) {
      console.error(error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("❌ Erreur lors de la validation !");
    }
  };

  const handleArchive = async (todoId) => {
    const confirmArchive = await dialog.confirm(
      "Voulez-vous vraiment archiver cette tâche ?"
    );
    if (!confirmArchive) return;

    const todoToArchive = findTodoById(todoId);

    // UI instantanée : la ligne part aux archives tout de suite
    patchTodoLocal(todoId, {
      status: "Archiver",
      lastStatus: todoToArchive?.status,
    });
    setOpenMenuId(null);
    setSelectedMenuTodo(null);

    try {
      const response = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todoId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            status: "Archiver",
            lastStatus: todoToArchive?.status,
          }),
        }
      );

      if (!response.ok) throw new Error("Erreur lors de l'archivage");

      fetchTodos();
    } catch (error) {
      console.error(error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("❌ Erreur lors de l'archivage.");
    }
  };

  const handleDelete = async (todoId) => {
    const confirmDelete = await dialog.confirm(
      "Voulez-vous vraiment supprimer cette tâche ?"
    );
    if (!confirmDelete) return;

    // UI instantanée : la ligne disparaît tout de suite
    removeTodoLocal(todoId);
    setOpenMenuId(null);
    setSelectedMenuTodo(null);

    try {
      const response = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todoId}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) throw new Error("Erreur lors de la suppression");

      fetchTodos();
    } catch (error) {
      console.error(error);
      fetchTodos(); // resynchronise l'état réel (la ligne réapparaît)
      dialog.alert("❌ Erreur lors de la suppression.");
    }
  };

  return (
    <div>
      <div className="mb-5 ">
        <h1 className="text-xl font-semibold text-gray-900 m-0">
          Suivi des tâches
        </h1>
        <p className="text-xs text-gray-400 mt-1">
          Vue d'ensemble des tâches et de l'équipe
        </p>
      </div>

      <div className="flex items-center justify-between gap-4 mb-5">
        {/* Zone de recherche */}
        <div className="relative flex-1 max-w-xs">
          <IoIosSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
          <input
            type="text"
            placeholder="Filtrer par nom du dossier..."
            value={searchClient}
            onChange={(e) => setSearchClient(e.target.value.toLowerCase())}
            className="pl-8 h-8 w-full rounded-full bg-white border border-gray-200 text-xs focus:outline-none focus:border-gray-300"
          />
        </div>
        <div className="flex items-center gap-2 pr-[2%]">
          <button
            onClick={() => setShowArchives(!showArchives)}
            className={`flex items-center gap-1.5 h-8 px-3 rounded-lg text-xs font-medium transition-colors ${
              showArchives
                ? "bg-gray-100 text-gray-700 border border-gray-200"
                : "bg-white text-gray-600 border border-gray-200 hover:bg-gray-50"
            }`}
          >
            <Archive className="w-3 h-3" />
            {showArchives ? "Retour" : "Archive"}
          </button>
          <button
            onClick={() => setShowFilterOverlay(!showFilterOverlay)}
            className="flex items-center gap-1.5 h-8 px-3 rounded-lg text-xs font-medium bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 transition-colors"
          >
            <CiFilter className="w-3 h-3" />
            Filtrer
          </button>
          <button
            onClick={() => setShowAddDiv(!showAddDiv)}
            className="flex items-center gap-1.5 h-8 px-4 rounded-lg text-xs font-semibold text-white bg-[#840040] hover:bg-[#6c0034] transition-colors"
          >
            <Plus className="w-3 h-3" />
            Ajouter une tâche
          </button>
        </div>
        {showFilterOverlay && (
          <div
            ref={overlayRef}
            className="absolute top-40 right-0 -translate-x-1/2 bg-white border border-slate-200 rounded-lg p-3 shadow-lg z-50 w-2/5"
          >
            <div className="flex justify-between mb-1.5">
              <p className="font-semibold text-[11px] text-gray-700">
                Filtres avancés
              </p>
              <button
                onClick={() =>
                  setFilterRows([{ column: "status", selectedValues: [] }])
                }
                className="text-[11px] text-slate-600 hover:text-slate-800"
              >
                Réinitialiser
              </button>
            </div>

            {filterRows.map((f, idx) => (
              <div key={idx} className="mb-2">
                <div className="flex items-center justify-between mb-1">
                  <select
                    value={f.column}
                    onChange={(e) =>
                      handleFilterChange(idx, "column", e.target.value)
                    }
                    className="border border-slate-200 rounded-md px-1 py-0.5 text-[11px] text-gray-600"
                  >
                    {Object.keys(uniqueValues).map((col) => {
                      const labelMap = {
                        status: "Statut",
                        priority: "Priorité",
                        nomClient: "Client",
                        title: "Tâches",
                        users: "Collaborateurs",
                        dueDate: "Date d'échéance",
                      };

                      return (
                        <option key={col} value={col}>
                          {labelMap[col] || col}
                        </option>
                      );
                    })}
                  </select>
                  <button
                    onClick={() => handleRemoveFilter(idx)}
                    className="text-[11px] text-red-600 hover:text-red-800"
                  >
                    Supprimer
                  </button>
                </div>
                <div className="flex flex-col ml-2">
                  {uniqueValues[f.column]?.map((val) => (
                    <label key={val} className="text-[11px] text-gray-600">
                      <input
                        type="checkbox"
                        checked={f.selectedValues.includes(val)}
                        onChange={() => handleCheckboxValueChange(idx, val)}
                        className="mr-1.5 h-3 w-3"
                      />
                      {val}
                    </label>
                  ))}
                </div>
              </div>
            ))}
            <button
              className="text-[11px] text-slate-700 hover:text-slate-900 mt-1.5"
              onClick={handleAddFilter}
            >
              + Ajouter un filtre
            </button>
          </div>
        )}
      </div>

      {/* SECTION STATS USERS */}
      <div className="grid grid-cols-6 gap-3 mb-6">
        {userStats.map((user) => {
          const isActive = selectedUserKey === user.userKey;

          return (
            <div
              key={user.userKey}
              onClick={() => setSelectedUserKey(isActive ? null : user.userKey)}
              className={`bg-white rounded-xl p-3 border transition-all cursor-pointer ${
                isActive
                  ? "border-[#6c1935] "
                  : "border-gray-100 hover:shadow-sm hover:border-gray-200"
              }`}
            >
              {/* Header */}
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-full bg-[#5C1A30] flex items-center justify-center text-white font-bold text-[10px] flex-shrink-0">
                  {user.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                    .toUpperCase()
                    .slice(0, 2)}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-gray-900 truncate text-xs m-0 leading-tight">
                    {user.name}
                  </h3>
                  <p className="text-[10px] text-gray-400 mt-0.5">
                    {user.total} tâche{user.total > 1 ? "s" : ""}
                  </p>
                </div>
              </div>

              {/* Stats */}
              <div className="flex gap-1">
                <div className="flex-1 bg-[#fff8dc] rounded py-1 text-center">
                  <p className="text-[10px] font-medium text-[#8b6a0f] leading-none">
                    {user.enCours}
                  </p>
                </div>
                <div className="flex-1 bg-[#dcf3e1] rounded py-1 text-center">
                  <p className="text-[10px] font-medium text-[#2a6d3c] leading-none">
                    {user.finalise}
                  </p>
                </div>
                <div className="flex-1 bg-[#fbe3e3] rounded py-1 text-center">
                  <p className="text-[10px] font-medium text-[#bb4b4b] leading-none">
                    {user.enRetard}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {showArchives ? (
        <div>
          <div>
            <Archives
              todos={todos}
              fetchTodos={fetchTodos}
              setTodos={setTodos}
            />
          </div>
        </div>
      ) : (
        <>
          {showAddDiv && (
            <CreateTodo setShowAddDiv={setShowAddDiv} fetchTodos={fetchTodos} />
          )}
          {/* Bouton filtres avancés */}

          <div className="flex flex-col gap-5">
            {displayedTodos.map((userBlock) => (
              <div key={userBlock.userKey}>
                {/* Header barre bordeaux */}
                <div
                  onClick={() => toggleUserCollapse(userBlock.userKey)}
                  className="flex items-center gap-3 cursor-pointer px-4 py-2.5 bg-[#5C1A30] rounded-xl mb-2"
                >
                  <ChevronDown
                    size={14}
                    className={`text-white transition-transform duration-300 ${
                      collapsedUsers[userBlock.userKey] ? "rotate-180" : ""
                    }`}
                  />
                  <p className="m-0 text-white font-semibold text-xs">
                    {userBlock.name} {userBlock.lastName}
                  </p>
                  <div className="bg-white/20 text-white text-[10px] px-2.5 py-0.5 rounded-full font-medium">
                    {
                      userBlock.todos.filter(
                        (todo) => todo.status !== "Archiver"
                      ).length
                    }
                  </div>
                </div>

                {!collapsedUsers[userBlock.userKey] && (
                  <table className="w-full bg-white rounded-xl shadow-sm overflow-hidden">
                    <thead className="bg-[#fff6ee] w-full">
                      <tr className="border-b border-gray-100">
                        <th className="w-10"></th>
                        <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                          Client
                        </th>
                        <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                          Tâche
                        </th>
                        <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                          Priorité
                        </th>
                        <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                          Échéance
                        </th>
                        <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                          Collaborateurs
                        </th>
                        <th className="w-10"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                      {userBlock.todos
                        .filter((todo) => todo.status !== "Archiver")
                        .sort(
                          (a, b) =>
                            new Date(b.createdAt) - new Date(a.createdAt)
                        )
                        .map((todo) => (
                          <tr
                            key={todo.id}
                            data-todo-id={todo.id}
                            onClick={() => setSelectedClient(todo)}
                            className={`cursor-pointer transition-all ${
                              animatingId === todo.id
                                ? "border-l-4 todo-row-validating"
                                : isOverdue(todo)
                                ? "hover:bg-red-100 border-l-4"
                                : isTerminer(todo)
                                ? "bg-green-100 hover:bg-green-100 border-l-4"
                                : "hover:bg-slate-50"
                            }`}
                          >
                            <td className="px-3 py-2.5">
                              <input
                                type="checkbox"
                                checked={selectedTodos.includes(todo.id)}
                                onChange={() => toggleSelection(todo.id)}
                                onClick={(e) => e.stopPropagation()}
                                className="h-3.5 w-3.5 rounded border-gray-300 cursor-pointer"
                              />
                            </td>
                            <td className="px-4 py-2.5 cursor-pointer relative overflow-visible">
                              {animatingId === todo.id && (
                                <span className="todo-done-badge">✓ Terminé !</span>
                              )}
                              <div className="flex items-center gap-1.5">
                                {isOverdue(todo) && (
                                  <AlertCircle className="w-3.5 h-3.5 text-red-500 flex-shrink-0" />
                                )}
                                {(isTerminer(todo) || animatingId === todo.id) && (
                                  <span className="relative inline-flex flex-shrink-0">
                                    {animatingId === todo.id && (
                                      <>
                                        <span className="todo-ripple-ring" />
                                        <span className="todo-ripple-ring-2" />
                                      </>
                                    )}
                                    <CheckCircle2
                                      className={`w-3.5 h-3.5 text-green-500 ${animatingId === todo.id ? "todo-check-pop" : ""}`}
                                    />
                                  </span>
                                )}
                                <span
                                  className={`text-xs font-semibold ${
                                    isOverdue(todo)
                                      ? "text-[#840040]"
                                      : "text-gray-800"
                                  }`}
                                >
                                  {todo.nomClient}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-2.5">
                              <div className="flex flex-col gap-0.5">
                                <div className="tooltip-container text-xs font-medium text-gray-800">
                                  {todo.title
                                    ? todo.title
                                        .split(" ")
                                        .slice(0, 5)
                                        .join(" ") +
                                      (todo.title.split(" ").length > 5
                                        ? "..."
                                        : "")
                                    : " - "}
                                  {todo.title && (
                                    <div className="tooltip-text">
                                      {todo.title}
                                    </div>
                                  )}
                                </div>
                                <div className="tooltip-container text-[10px] text-gray-400">
                                  {todo.commentaire
                                    ? todo.commentaire
                                        .split(" ")
                                        .slice(0, 5)
                                        .join(" ") +
                                      (todo.commentaire.split(" ").length > 5
                                        ? "..."
                                        : "")
                                    : ""}
                                  {todo.commentaire && (
                                    <div className="tooltip-text">
                                      {todo.commentaire}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>

                            <td className="px-4 py-2.5">
                              <span
                                className={`px-2.5 py-1 rounded-full text-[10px] font-medium ${
                                  todo.priority === "élevé" ||
                                  todo.priority === "haute"
                                    ? "bg-red-50 text-red-400"
                                    : todo.priority === "moyenne"
                                    ? "bg-yellow-50 text-yellow-600"
                                    : "bg-gray-100 text-gray-500"
                                }`}
                              >
                                {todo.priority || "-"}
                              </span>
                            </td>

                            <td
                              className={`px-4 py-2.5 text-[11px] font-medium ${
                                isOverdue(todo)
                                  ? "text-red-500"
                                  : "text-gray-400"
                              }`}
                            >
                              {todo.dueDate
                                ? new Date(todo.dueDate).toLocaleDateString()
                                : "-"}
                            </td>

                            <td className="px-4 py-2.5 text-xs font-semibold text-gray-600">
                              {todo.users && todo.users.length > 0 ? (
                                <span
                                  className="hover-name"
                                  title={todo.users
                                    .map((u) => `${u.name} ${u.lastName}`)
                                    .join(", ")}
                                >
                                  {todo.users
                                    .map((u) => {
                                      const nomInitial =
                                        u.lastName?.[0]?.toUpperCase() || "";
                                      const prenomInitial =
                                        u.name?.[0]?.toUpperCase() || "";
                                      return `${prenomInitial}${nomInitial}`;
                                    })
                                    .join("-")}
                                </span>
                              ) : (
                                "—"
                              )}
                            </td>

                            <td className="px-2 py-2.5">
                              <button
                                className="p-1.5 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                                onClick={(e) => handleMenuToggle(e, todo)}
                              >
                                <MoreHorizontal size={14} />
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {selectedClient &&
        (selectedClient.type === "Preparation" ? (
          <PreparationPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "Diligences" ? (
          <DiligencePopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "evenement" ? (
          <EvenementPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "Verification" ? (
          <VerificationPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "dext" ? (
          <DextPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "autres" ? (
          <AutresPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "" ? (
          <AutresPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "SuiviBilan" ? (
          <AutresPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "SuiviSocial" ? (
          <AutresPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "Mission" ? (
          <ModifSct
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "MissionModifSoc" ? (
          <ModifSct
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "MissionDroitSoc" ? (
          <CessionDroit
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "MissionCreation" ? (
          <CreationSct
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "Radiation" ? (
          <Radiation
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : (
          // <MissionPopup
          //   client={selectedClient}
          //   onClose={() => setSelectedClient(null)}
          // />
          <AutresPopup
            key={selectedClient?.id} // ajoute ça
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ))}

      {selectedTodos.length > 0 && (
        <div className="ClientOption">
          <div className="COption">
            <div className="IdL">
              <p>{selectedTodos.length}</p>
            </div>
            <div className="btnOption">
              <p>Dossier sélectionné(e)</p>
              <div className="sbtnOption" onClick={handleMultiArchive}>
                <HiMiniArchiveBox size={15} color="#840040" />
                <p>{isArchiving ? "Archivage..." : "Archiver"}</p>
              </div>
              <div className="sbtnOption" onClick={handleMultiDelete}>
                <AiOutlineDelete size={15} color="#840040" />
                <p>{isDeleting ? "Suppression..." : "Supprimer"}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditForm && (
        <div className="overlayAC">
          <div className="inoverlayLead">
            <button
              className="close-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowEditForm(false);
              }}
              style={{
                position: "absolute",
                top: "40px",
                right: "420px",
                background: "transparent",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
            <EditTodoForm
              formData={formData}
              editLoading={editLoading}
              isSubmitting={false}
              handleFormChange={handleFormChange}
              handleUserIdsChange={handleUserIdsChange}
              handleFormSubmit={handleFormSubmit}
              onCancel={() => setShowEditForm(false)}
            />
          </div>
        </div>
      )}

      {/* Menu flottant en position fixed pour échapper aux overflow:hidden des tableaux */}
      {openMenuId && selectedMenuTodo && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "fixed",
            top: menuPosition.top,
            right: menuPosition.right,
            zIndex: 9999,
          }}
          className="w-44 bg-white rounded-lg shadow-lg border border-gray-100"
        >
          {(utilisateur.role === "ADMINISTRATEUR" ||
            utilisateur.role === "EXPERT_COMPTABLE" ||
            utilisateur.role === "SECRETARIAT") && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(selectedMenuTodo);
                setOpenMenuId(null);
                setSelectedMenuTodo(null);
              }}
              className="flex items-center w-full px-3 py-2 text-xs text-gray-700 hover:bg-gray-50 transition"
            >
              <Pencil className="w-3.5 h-3.5 mr-2" />
              Modifier
            </button>
          )}
          <button
            onClick={() => handleValidate(selectedMenuTodo.id)}
            className="flex items-center w-full px-3 py-2 text-xs text-gray-700 transition hover:bg-emerald-50"
          >
            <CheckCircle2 className="w-3.5 h-3.5 mr-2 text-emerald-600" />
            Marquer terminé
          </button>
          <button
            onClick={() => handleArchive(selectedMenuTodo.id)}
            className="flex items-center w-full px-3 py-2 text-xs text-gray-700 transition hover:bg-gray-50"
          >
            <Archive className="w-3.5 h-3.5 mr-2" />
            Archiver
          </button>
          <div className="border-t border-gray-100 my-1" />
          <button
            onClick={() => handleDelete(selectedMenuTodo.id)}
            className="flex items-center w-full px-3 py-2 text-xs text-red-500 transition hover:bg-red-50"
          >
            <Trash2 className="w-3.5 h-3.5 mr-2" />
            Supprimer
          </button>
        </div>
      )}
    </div>
  );
}

export default ToDo;
